// src/pages/Testimonials/Testimonials.js
import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import './Testimonials.css';

const testimonialsData = [
  {
    image: '/images/client1.webp',
    quote: 'UBR Engineering Works delivered beyond our expectations. The machine quality is unmatched!',
    name: 'Mr. Suresh Verma',
    designation: 'Production Manager, SteelTech Pvt. Ltd.',
  },
  {
    image: '/images/client2.webp',
    quote: 'Their team is responsive and professional. Highly recommend for heavy engineering needs.',
    name: 'Ms. Anita Rao',
    designation: 'Operations Head, AutoPro Gears',
  },
  {
    image: '/images/client3.webp',
    quote: 'Precision and performance — exactly what we needed. UBR is our trusted partner.',
    name: 'Mr. Rajiv Mehta',
    designation: 'MD, Mehta Metal Works',
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonial-section">
      <Helmet>
        <title>Client Testimonials | UBR Engineering Works</title>
        <meta
          name="description"
          content="See what our clients say about UBR Engineering Works. Trusted by leading industries for premium engineering machinery and services."
        />
        <meta
          name="keywords"
          content="UBR Engineering testimonials, client reviews, machinery feedback, industrial machine clients, trusted engineering company"
        />
        <meta name="author" content="UBR Engineering Works" />
      </Helmet>

      <h2 className="testimonial-title">What Our Clients Say</h2>
      <div className="testimonial-underline"></div>

      <div className="testimonial-cards">
        {testimonialsData.map((testimonial, index) => (
          <motion.div
            key={index}
            className="testimonial-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{
              scale: 1.03,
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
              border: '2px solid #00bcd4',
            }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <img
              src={testimonial.image}
              alt={`Testimonial from ${testimonial.name}`}
              className="testimonial-img"
              loading="lazy"
              decoding="async"
            />
            <p className="testimonial-quote">"{testimonial.quote}"</p>
            <h4 className="testimonial-name">{testimonial.name}</h4>
            <p className="testimonial-role">{testimonial.designation}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
